import { render } from "./ApproveWallet.vue?vue&type=template&id=bf84a58e&scoped=true"
import script from "./ApproveWallet.vue?vue&type=script&lang=js"
export * from "./ApproveWallet.vue?vue&type=script&lang=js"

import "./ApproveWallet.vue?vue&type=style&index=0&id=bf84a58e&scoped=true&lang=scss"

import exportComponent from "/home/parmcoder/muic/Deguild-Project/deguild-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bf84a58e"]])

export default __exports__